import React from 'react';
import { connect } from 'react-redux';
import AdvertOverlay from '../AdvertOverlay';
import GalleryOverlay from '../GalleryOverlay';
import NewItemsOverlay from '../NewsItemOverlay';
import ContactUsOverlay from '../ContactUsOverlay';
import PropertyManagerOverlay from '../PropertyManagerOverlay';
import ContestInfoOverlay from '../ContestOverlay';

import { ServiceRequestOverlayDetail } from '../../features/servicerequest/components';

export enum ModalName {
  Advert = 'Advert',
  Gallery = 'Gallery',
  NewItems = 'NewItems',
  ContactUs = 'ContactUs',
  PropertyManager = 'PropertyManager',
  ServiceRequestDetail = 'ServiceRequestDetail',
  ContestInfo = 'ContestInfo',
}

type ModalMapping = {
  [ModalName.Advert]: React.FC<any>;
  [ModalName.Gallery]: React.FC<any>;
  [ModalName.NewItems]: React.FC<any>;
  [ModalName.ContactUs]: React.FC<any>;
  [ModalName.PropertyManager]: React.FC<any>;
  [ModalName.ServiceRequestDetail]: React.FC<any>;
  [ModalName.ContestInfo]: React.FC<any>;
};

const modalMapping: ModalMapping = {
  [ModalName.Advert]: AdvertOverlay,
  [ModalName.Gallery]: GalleryOverlay,
  [ModalName.NewItems]: NewItemsOverlay,
  [ModalName.ContactUs]: ContactUsOverlay,
  [ModalName.PropertyManager]: PropertyManagerOverlay,
  [ModalName.ServiceRequestDetail]: ServiceRequestOverlayDetail,
  [ModalName.ContestInfo]: ContestInfoOverlay,
};

export interface RootModalProps {
  modalProps?: any;
  isShowModal?: boolean;
  modalName?: ModalName;
}

const RootModal = ({ modalProps, isShowModal, modalName }: RootModalProps) => {
  console.log('root modal render');
  if (!isShowModal || !modalName) {
    return null;
  }
  console.log('root modal render', modalName);
  // replace with default modals
  const ModalContent = modalMapping[modalName];
  return <ModalContent {...modalProps} />;
};

const mapStateToProps = (state: any) => ({
  isShowModal: state.app.isShowModal,
  modalProps: state.app.modalProps,
  modalName: state.app.modalName,
});

export default connect(mapStateToProps, null)(RootModal);
